/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ManagementBusinessEntityResponse } from './managementBusinessEntityResponse';

export interface ManagementSaleResponse { 
    id: string;
    trustees?: Array<ManagementBusinessEntityResponse>;
    debtors?: Array<ManagementBusinessEntityResponse>;
    locations?: Array<string>;
    placesOfSale?: Array<string>;
    publicationUrl?: string;
    fileUrl?: string;
    type?: ManagementSaleResponse.TypeEnum;
    publicationDate?: Date;
    saleDate?: Date;
    text?: string;
    createdAt?: Date;
    eSale?: boolean;
}
export namespace ManagementSaleResponse {
    export type TypeEnum = 'REAL_ESTATE' | 'MOVABLE_PROPERTY' | 'REAL_MOVABLE' | 'BUILDABLE_LAND' | 'LEASE_RENTAL' | 'AMENDMENT' | 'CANCELLATION';
    export const TypeEnum = {
        REALESTATE: 'REAL_ESTATE' as TypeEnum,
        MOVABLEPROPERTY: 'MOVABLE_PROPERTY' as TypeEnum,
        REALMOVABLE: 'REAL_MOVABLE' as TypeEnum,
        BUILDABLELAND: 'BUILDABLE_LAND' as TypeEnum,
        LEASERENTAL: 'LEASE_RENTAL' as TypeEnum,
        AMENDMENT: 'AMENDMENT' as TypeEnum,
        CANCELLATION: 'CANCELLATION' as TypeEnum
    };
}